import cx from 'classnames';
import dayjs from 'dayjs';

import type { AdminUser } from 'api/adminApi';
import { ONBOARDING_STEPS, OnboardingStepId } from 'utils/onboardingSteps';

import styles from './style.module.scss';

type OnboardingStepsListProps = {
    currentStep: OnboardingStepId;
    user: AdminUser;
};

export const OnboardingStepsList = ({ currentStep, user }: OnboardingStepsListProps) => {
    return (
        <ol className={styles.list}>
            {ONBOARDING_STEPS.map((step) => {
                const isCompleted = step.id < currentStep;
                const isCurrent = step.id === currentStep;
                const timestamp = step.timestampField ? user[step.timestampField] : null;

                return (
                    <li
                        key={step.id}
                        className={cx(styles.item, {
                            [styles.completed]: isCompleted,
                            [styles.current]: isCurrent,
                        })}
                    >
                        <span className={styles.stepNumber}>{step.id}</span>

                        <span className={styles.stepTitle}>{step.title}</span>

                        {typeof timestamp === 'string' && (
                            <span className={styles.stepDate}>{dayjs(timestamp).format('DD.MM.YYYY HH:mm')}</span>
                        )}
                    </li>
                );
            })}
        </ol>
    );
};
